export default __webpack_public_path__ + "static/media/R_C.7bffa888.png";